import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ImageProcess1 = ({ className }) => {
  const data = useStaticQuery(graphql`
    {
      process1: file(relativePath: { eq: "blog/process-1.jpg" }) {
        childImageSharp {
          gatsbyImageData(
            width: 500
            placeholder: DOMINANT_COLOR
            layout: CONSTRAINED
          )
        }
      }
    }
  `)

  return <GatsbyImage image={getImage(data.process1)} className={className} />
}

export default ImageProcess1
